module.exports = __webpack_public_path__ + "img/a.6101aece.jpg";